export default __webpack_public_path__ + "static/media/Church Ceremony-0137.da248974.jpg";